export default "__VITE_ASSET__14e6f1b0__"